import { Helmet } from "react-helmet";
import Breadcrumb from "../components/Breadcrumb";
import classes from "./PrivacyPolicy.module.css";
import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  return (
    <>
      <Helmet>
        <title>
          Privacy And Cookie Policy - How TechMatter UK Protects Your Personal
          Data
        </title>
        <meta
          name="description"
          content="At TechMatter UK, your privacy matters. Learn how we securely collect, use, and protect customer information while shopping for IT hardware online."
        />
        <link rel="canonical" href="https://techmatter.co.uk/privacy-policy" />
      </Helmet>

      <Breadcrumb currentPage="Privacy And Cookie Policy" />
      <div className={`container ${classes.privacyPolicyContainer}`}>
        <p className={classes.paragraph}>
          Our privacy policy outlines how we at Techmatter utilize and safeguard
          any information you provide us when you interact with us through this
          website or by other methods such as phone, email, or written
          communication. Safeguarding your privacy is our top priority. If we
          request personal information from you while you use our website, we
          will only use it in compliance with our privacy policy. Techmatter
          reserves the right to update this policy, so please check this page
          periodically to ensure your satisfaction.
        </p>
        <h2 className={classes.subheading}>1. What we collect</h2>
        <p className={classes.paragraph}>
          We collect information from you when you register with us or place an
          order for products and services. We also collect information when you
          voluntarily provide feedback such as by completing surveys or using
          our online configuration tools. Website usage information is collected
          using cookies. We may collect the following information:
        </p>
        <p className={classes.paragraph}>
          1.1. Personal information such as your name and job title
        </p>
        <p className={classes.paragraph}>
          1.2. Contact information including email address and telephone numbers
        </p>
        <p className={classes.paragraph}>
          1.3. Demographic information such as address details, preferences and
          interests
        </p>
        <p className={classes.paragraph}>
          1.4. Other information relevant to online forms, surveys and/or offers
        </p>
        <h2 className={classes.subheading}>
          2. What we do with the information we gather
        </h2>
        <p className={classes.paragraph}>
          Information stored or collected regarding you helps us:
        </p>
        <ul className={classes.list}>
          <li>process your orders</li>
          <li>manage your account</li>
          <li>provide or improve services you need</li>
          <li>
            contact you about products and services we think may be of interest
            to you
          </li>
        </ul>
        <p className={classes.paragraph}>
          2.1. Any request you make of our site or personnel permits us to use
          information you provide in relation to the products or services we
          have. We may also send information on products or services you may be
          interested in.
        </p>
        <p className={classes.paragraph}>
          2.2. To meet any contract commitments, we make to you.
        </p>
        <p className={classes.paragraph}>
          2.3. Changes or improvements made to the site may warrant use of your
          information, with regard to notification of such changes.
        </p>
        <p className={classes.paragraph}>
          2.4. An existing customer may be contacted regarding products and
          services related to any item of previous sale you made on our site.
        </p>
        <p className={classes.paragraph}>
          2.5. Any new customer can only be contacted if consent has been
          offered via our site. We only send communications you have consented
          to.
        </p>
        <p className={classes.paragraph}>
          2.6. Anyone who does not wish to give consent for our site or
          third-party use has the opportunity to decline. Once we receive your
          withhold for consent we will remove your details from any mailings or
          third party communications.
        </p>{" "}
        <p className={classes.paragraph}>
          We would like to send you information about products and services of
          ours and other companies we are affiliated with which may be of
          interest to you. If you have consented to receive marketing, you may
          opt out at a later date. You have a right at any time to stop us from
          contacting you for marketing purposes. If you no longer wish to be
          contacted for marketing purposes, please{" "}
          <Link to="mailto:sales@techmatter.co.uk">sales@techmatter.co.uk</Link>
        </p>
        <h2 className={classes.subheading}>
          3. Access to your data and correction
        </h2>
        <p className={classes.paragraph}>
          You have the right to request a copy of the information that we hold
          about you. If you would like a copy of some or all of your personal
          information, please{" "}
          <Link to="mailto:sales@techmatter.co.uk">sales@techmatter.co.uk</Link>
        </p>
        <h2 className={classes.subheading}>4. Security</h2>
        <p className={classes.paragraph}>
          We are committed to ensuring that your information is secure. In order
          to prevent unauthorized access or disclosure, we have put in place
          suitable physical, electronic and managerial procedures to safeguard
          and secure the information we collect online. 4.1. Information we are
          provided will be stored on secure servers. Transaction data is
          encrypted for your safety. 4.2. You should understand data transmitted
          online is not completely secure. We cannot guarantee full protection
          and security data, only that we take all reasonable action to protect
          information sent to us electronically. Transmission of any data by you
          is at your own risk. Where applicable you may be given access to
          sections of our site that require a password. You are responsible for
          password safety and confidentiality.
        </p>
        <h2 className={classes.subheading}>5. How we use cookies</h2>
        <p className={classes.paragraph}>
          A cookie is a small file which asks permission to be placed on your
          computer’s hard drive. Once you agree, the file is added and the
          cookie helps analyses web traffic or lets you know when you visit a
          particular site. Cookies allow web applications to respond to you as
          an individual. The web application can tailor its operations to your
          needs, likes and dislikes by gathering and remembering information
          about your preferences. We use traffic log cookies to identify which
          pages are being used. This helps us analyses data about web page
          traffic and improve our website in order to tailor it to customer
          needs. We only use this information for statistical analysis purposes
          and then the data is removed from the system. Overall, cookies help us
          provide you with a better website, by enabling us to monitor which
          pages you find useful and which you do not. A cookie in no way gives
          us access to your computer or any information about you, other than
          the data you choose to share with us. You can choose to accept or
          decline cookies. Most web browsers automatically accept cookies, but
          you can usually modify your browser setting to decline cookies if you
          prefer. This may prevent you from taking full advantage of the
          website. The table below lists the cookies we collect and what
          information they store. If you have any queries in relation to the
          information we capture you can contact at the email address{" "}
          <Link to="mailto:sales@techmatter.co.uk">sales@techmatter.co.uk</Link>
        </p>
        <h2 className={classes.subheading}>6. Links to other websites</h2>
        <p className={classes.paragraph}>
          Our website may contain links to other websites of interest. However,
          once you have used these links to leave our site, you should note that
          we do not have any control over that other website. Therefore, we
          cannot be responsible for the protection and privacy of any
          information which you provide while visiting such sites and such sites
          are not governed by this privacy statement. You should exercise
          caution and look at the privacy statement applicable to the website in
          question.
        </p>{" "}
        <h2 className={classes.subheading}>
          7. Information accessibility and disclosure
        </h2>
        <p className={classes.paragraph}>
          7.1. We may disclose your personal information to a Third party for
          any of the following reasons:
        </p>{" "}
        <p className={classes.paragraph}>
          7.1.1. Selling any or all of our business to a third party may result
          in sharing your information.
        </p>{" "}
        <p className={classes.paragraph}>
          7.1.2. At any time when we are legally required to we may disclose
          information about you and your visits to our sites.
        </p>{" "}
        <p className={classes.paragraph}>
          7.1.3. To prevent fraud and help in fraud protection in order to
          reduce credit risk. We will not otherwise sell, distribute or lease
          your personal information to third parties unless we have your
          permission or are required by law to do so.
        </p>{" "}
        <p className={classes.paragraph}>
          7.2. We may use your personal information to send you promotional
          information about third parties which we think you may find
          interesting.
        </p>
        <h2 className={classes.subheading}>8. Contacting us</h2>
        <p className={classes.paragraph}>
          Please feel free to contact with queries, requests, or comments you
          may have about our Privacy Policy. We welcome any communication via
          the email address supplied here:{" "}
          <Link to="mailto:sales@techmatter.co.uk">sales@techmatter.co.uk</Link>
        </p>
      </div>
    </>
  );
}
